import { OrderStatus } from 'src/types';
import type {
  EditOrderGuardInput,
  EditOrderGuardResult,
} from 'src/types/loaders';
import { isCustomerSuccessOrSalesUser } from 'src/utils';

export function getEditOrderRedirect(
  input: EditOrderGuardInput,
): EditOrderGuardResult {
  const { order, redirectBasePath, orderId } = input;
  const isCSOrSalesUser = isCustomerSuccessOrSalesUser();
  const redirectPath = `${redirectBasePath}/orders/${orderId}`;

  if (!isCSOrSalesUser) {
    return {
      redirectPath,
      errorMessage: 'You are not authorized to edit this order.',
    };
  }

  if (order.status !== OrderStatus.QualityControlPending) {
    return {
      redirectPath,
      errorMessage: 'This order cannot be edited at this time.',
    };
  }

  return null;
}
